import { EBAY, ETSY, FAIRE, SHOPIFY } from '@/constants/channels';

export const CHANNEL_DATA_KEYS = {
  [EBAY]: [
    'TAXONOMY',
  ],
  [ETSY]: [
    'SCALES_LOOKUP',
    'STANDARD_PROPERTIES',
    'SUGGESTED_OPTIONS_LOOKUP',
    'TAXONOMY',
    'TAXONOMY_SPECIFIC_PROPERTIES',
  ],
  [FAIRE]: [
    'TAXONOMY',
    'EXCHANGE_RATES',
  ],
  [SHOPIFY]: [
    'COUNTRIES_LIST',
    'COUNTRIES_MAP',
    'TAXONOMY',
    'TAXONOMY_ATTRIBUTES',
    'TAXONOMY_ATTRIBUTE_VALUES',
  ],
};
